import { render, staticRenderFns } from "./ImageVerify.vue?vue&type=template&id=ad2f74f2&scoped=true&"
import script from "./ImageVerify.vue?vue&type=script&lang=js&"
export * from "./ImageVerify.vue?vue&type=script&lang=js&"
import style0 from "./ImageVerify.vue?vue&type=style&index=0&id=ad2f74f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2f74f2",
  null
  
)

export default component.exports